// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { fantomSonicTestnet as _fantomSonicTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the fantomSonicTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 64240
 * Chain Name: Fantom Sonic Open Testnet
 * Default Block Explorer: https://public-sonic.fantom.network
 * Default RPC URL: https://rpcapi.sonic.fantom.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { fantomSonicTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: fantomSonicTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const fantomSonicTestnet = createCommon({
	..._fantomSonicTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
